async function getCart() {
  return fetch('/cart.js').then(r => r.json());
}

function isDiceDashItem(item) {
  return item.properties && item.properties._dice_dash;
}

document.addEventListener('submit', async function (e) {
  const form = e.target;
  if (!form.matches('form[action="/cart/add"]')) return;

  const cart = await getCart();
  const hasDiceDash = cart.items.some(isDiceDashItem);

  const formData = new FormData(form);
  const isNewDiceDash = formData.get('properties[_dice_dash]');

  if (hasDiceDash && !isNewDiceDash) {
    e.preventDefault();
    alert("You can't mix Dice Dash items with normal products.");
  }

  if (!hasDiceDash && isNewDiceDash && cart.items.length > 0) {
    e.preventDefault();
    alert("Dice Dash orders must be separate from normal orders.");
  }
});